<template>
  <div class="rd-navbar-cart-button-wrap summary-cart-button dropdown relative-custom-header">
    <button @click="isOpenShoppingCart ? close(): openShoppingCart(true)" class="button-circle">
      <i class="fas fa-shopping-cart icon_cart"></i>
    </button>
    <div class="summary-cart-badge">{{ this.shoppingCart.totalItems() }}</div>
    <div v-if="isOpenShoppingCart" class="shopping-cart-summary">
      <div class="container-cart">
        <Loader :visible="loading"></Loader>
        <div class="container" v-if="this.shoppingCart.empty()">
          <div class="col-md-12 text-center">
            {{ $t("checkout.empty") }}
          </div>
        </div>
        <div v-if="!this.shoppingCart.empty() && !loading" class="container">
          <div class="row" v-for="item in this.shoppingCart.items">
            <div class="col-md-2 col-4 text-center">
              <img :src="item.preview" class="image-cart" v-if="item.photo_id"/>
              <img src="../../images/full-gallery.png" class="image-cart" v-if="item.photo_id == null"/>
            </div>
            <div class="col-md-7 col-4">
              <p class="item-name">{{ item.name }}</p>
            </div>
            <div class="col-md-3 col-4 text-center">
              <div v-if="item.discounts">
                <label class="price" :class="{'discount-price': item.discounts}">
                  {{ item.price | toCurrency }}
                </label>
                <span v-for="discount in shoppingCart.itemDiscounts(item)"
                      class="badge rounded-pill bg-danger badge-discount">
                {{ discount }}
              </span>
                <label class="price">
                  {{ item.total_price | toCurrency }}
                </label>
              </div>
              <div v-else>
                <label class="price">{{ item.price | toCurrency }}</label>
              </div>
              <button class="delete-item" @click="removeItem(item)">
                <i class="fas fa-trash-alt icon-trash"></i>
              </button>
            </div>
            <hr class="border-space"/>
          </div>
          <div class="row cart-summary">
            <div class="col-12" v-show="shoppingCart.hasMessage()">
              <label class="discount-legend">{{ shoppingCart.message }}</label>
            </div>
            <div class="col-4"></div>
            <div class="col-8">
              <div class="row" v-if="shoppingCart.hasTax()">
                <div class="col-8">
                  <p class="total-text">{{ $t("checkout.subTotal") }} :</p>
                </div>
                <div class="col-4">
                  <div class="total-amount">
                    {{ shoppingCart.summary.sub_total | toCurrency }}
                  </div>
                </div>
              </div>
              <div class="row" v-if="shoppingCart.hasTax()">
                <div class="col-8">
                  <p class="total-text">{{ shoppingCart.summary.tax_name }} :</p>
                </div>
                <div class="col-4">
                  <div class="total-amount">
                    {{ shoppingCart.summary.tax | toCurrency }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-8">
                  <p class="total-text">{{ $t("checkout.total") }} :</p>
                </div>
                <div class="col-4">
                  <div class="total-amount">
                    {{ shoppingCart.total() | toCurrency }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12" align="right">
                  {{ shoppingCart.summary.currency_name }}
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="button-card-preview">
          <button class="button-car-fixed" @click="checkout">
            {{ $t("checkout.buttonCart") }}
          </button>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Loader from '../../components/SmallLoader';
import ShoppingCart from '../../models/ShoppingCart';

export default {
  name: 'SummaryCar',
  components: {
    Loader
  },
  data() {
    return {
      loading: true,
      shoppingCart: new ShoppingCart()
    }
  },
  mounted() {
    this.closeShoppingCart();
    this.fetch();
    this.$root.$on('addItemToCart', this.addItemToCart);
  },
  methods: {
    ...mapActions('Web', ['closeShoppingCart', 'openShoppingCart']),
    ...mapActions('ShoppingCartStore', ['removeShoppingCartItem']),

    fetch() {
      this.loading = true;

      this.shoppingCart = this.getShoppingCart;
      this.shoppingCart.applyDiscounts();

      this.loading = false;
    },
    async removeItem(item) {
      this.loading = true;

      await this.removeShoppingCartItem(item.id);
      this.fetch();
      this.$root.$emit('recoverCard', '');

      this.loading = false;
    },
    addItemToCart() {
      this.fetch();
    },
    close() {
      this.closeShoppingCart();
    },
    checkout() {
      window.location.href = '/checkout';
    }
  },
  computed: {
    ...mapGetters('Web', ['isOpenShoppingCart']),
    ...mapGetters('ShoppingCartStore', ['getShoppingCart'])
  }
}
</script>

<style lang="scss">
@import "app/javascript/scss/variables";

.summary-cart-button {
  margin: 5px 10px;
  text-align: center;
}

.icon-trash {
  font-size: 20px;
  color: $primary-base !important;
}

.summary-cart-badge {
  pointer-events: none;
  position: absolute;
  top: -6px;
  right: -5px;
  background-color: #E72C59;
  height: 16px;
  line-height: 14px;
  min-width: 16px;
  text-align: center;
  color: $primary-base !important;
  font-size: 10px;
  font-weight: 600;
  border-radius: 8px;
}

.shopping-cart-summary {
  position: absolute;
  background: white;
  z-index: 1000;
  border-radius: 18px;
  right: -50px;
  top: 55px;
  width: 500px;
  height: 400px;
  overflow: scroll;
  -webkit-box-shadow: -1px 1px 6px 6px rgba(28, 28, 28, 0.12);
  box-shadow: -1px 1px 6px 6px rgba(28, 28, 28, 0.12);
  border-top-left-radius: 0;
  border-top-right-radius: 0;

  .container-cart {
    position: relative;
    height: 100%;
  }

  .row {
    margin-top: 0;
  }

  .delete-item {
    background: #FFFFFF;
    border-radius: 40px;
    text-align: center;
    width: 40px;
    height: 40px;
    -webkit-box-shadow: 5px -3px 15px -3px #000000;
    box-shadow: 5px -3px 15px -3px #000000;
    line-height: 45px;
    cursor: pointer;
  }

  .border-space {
    border: 1px solid #E8EBED;
  }

  .total-text, .total-amount {
    text-align: right;
    font-weight: bolder;
    margin-bottom: 0;
  }

  .total-text {
    font-size: 16px;
  }

  .total-amount {
    font-size: 17px;
    padding-right: 10px;
  }
}

.cart-summary {
  div.row, div.col-md-6 {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
}

.shopping-cart-summary, .shopping-cart-checkout {
  .image-cart {
    width: 100%;
  }

  .item-name {
    font-family: $font-bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    color: #000000;
  }

  .item-price {
    text-align: right;
    font-family: $font-light
  }
}

label.price {
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
}

.badge-discount {
  font-size: 10px;
  margin-right: 1px;
}

.discount-legend {
  color: green;
}

@media screen and (max-width: 768px) {
  .shopping-cart-summary {
    position: absolute;
    background: white;
    z-index: 1000;
    border-radius: 18px;
    right: -80px;
    top: 55px;
    width: 320px;
    height: 400px;
  }
}

@media screen and (max-width: 600px) {
  .cart_summary {
    position: absolute;
    background: white;
    z-index: 1000;
    border-radius: 18px;
    right: -80px;
    top: 49px;
    width: 300px;
    height: 600px;
    overflow: scroll;
  }
}

@media only screen and (max-width: 340px) and (min-width: 5px) {
  .shopping-cart-summary {
    position: absolute;
    background: white;
    z-index: 1000;
    border-radius: 18px;
    right: -25px;
    top: 55px;
    width: 260px;
    height: 400px;
  }
}
.button-card-preview{
  position: sticky;
  bottom: 0;
  background: white;
  padding: 4px;
  text-align: right;
  z-index: 1000;
}
.relative-custom-header{
  position: relative;
}
</style>
